module.exports = __webpack_public_path__ + "img/text.80d54966.png";